export interface FieldInputProps
	extends React.InputHTMLAttributes<HTMLInputElement> {
	label?: string;
	type?: "text" | "email" | "password" | "number" | "tel";
}

export function FieldInput({
	label,
	placeholder,
	value,
	onChange,
	type = "text",
	id,
	className,
	style,
	...props
}: FieldInputProps) {
	const inputId =
		id ??
		(label
			? `field-input-${label.toLowerCase().replace(/\s+/g, "-")}`
			: `field-input-${Math.random().toString(36).slice(2, 8)}`);

	return (
		<div
			className={className}
			style={{
				display: "flex",
				flexDirection: "column",
				gap: 6,
				...style,
			}}
		>
			{label && (
				<label
					htmlFor={inputId}
					style={{
						fontSize: 12,
						fontFamily: "var(--font-mono)",
						fontWeight: 600,
						letterSpacing: "0.08em",
						textTransform: "uppercase",
						color: "var(--color-dashboard-muted)",
					}}
				>
					{label}
				</label>
			)}
			<input
				id={inputId}
				type={type}
				placeholder={placeholder}
				value={value}
				onChange={onChange}
				style={{
					height: 40,
					paddingLeft: 14,
					paddingRight: 14,
					fontSize: 14,
					fontFamily: "var(--font-body)",
					color: "var(--color-dashboard-text)",
					background: "var(--color-dashboard-paper)",
					border: "1px solid var(--color-dashboard-border)",
					borderRadius: 7,
					outline: "none",
					transition: "border-color 200ms, box-shadow 200ms",
				}}
				onFocus={(e) => {
					e.currentTarget.style.borderColor = "var(--color-dashboard-accent)";
					e.currentTarget.style.boxShadow =
						"0 0 0 3px color-mix(in srgb, var(--color-dashboard-accent) 12%, transparent)";
				}}
				onBlur={(e) => {
					e.currentTarget.style.borderColor = "var(--color-dashboard-border)";
					e.currentTarget.style.boxShadow = "none";
				}}
				{...props}
			/>
		</div>
	);
}
